module.exports = __webpack_public_path__ + "img/cic.8bcc684e.png";